import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { CreateMechanicForm } from 'entities/mechanic';

export const DrawerMechanic = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent style={{ width: 900 }}>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Новая механика
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <CreateMechanicForm />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
